/* Cashify Play - GLOBAL cart guard + cart-UI sync + attach-games-after-booking. game = property _addon==='game'; else console.
   Guards, in priority order:
     1. multi-console  - more than one console line in the cart (one console per order)
     2. games-only     - add-on games with no console to attach them to

   NOTE: an older copy of this guard used to live in a Custom Liquid section on
   the cart template ("game-addons-cart-guard.liquid"). It only knew the
   games-only rule, so it stripped data-cpga-blocked and re-enabled checkout
   every 400ms - silently defeating this file. It has been removed from
   templates/cart.json. Do not re-add it.
*/
(function () {
  /* cache:'no-store' + a cache-buster: /cart.js can otherwise be served from
     the browser cache, and a stale copy makes the guard read the wrong cart. */
  function getCart() {
    return fetch('/cart.js?_=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  function clampAddons() {
    return getCart().then(function (cart) {
      var over = (cart.items || []).filter(function (it) { return it.properties && it.properties._addon === 'game' && it.quantity > 1; });
      if (!over.length) return cart;
      return over.reduce(function (p, it) {
        return p.then(function () {
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.key, quantity: 1 }) });
        });
      }, Promise.resolve()).then(getCart);
    });
  }

  function checkoutEls() {
    var list = [];
    ['button[name=checkout]', 'a[href*="/checkout"]', '[data-checkout]', '.cart__checkout', '.shopify-payment-button__button'].forEach(function (s) {
      Array.prototype.push.apply(list, document.querySelectorAll(s));
    });
    Array.prototype.forEach.call(document.querySelectorAll('button,a'), function (el) {
      var t = (el.textContent || '').trim().toLowerCase();
      if (t === 'proceed to checkout' || t === 'checkout' || t === 'check out') list.push(el);
    });
    return list.filter(function (v, i, a) { return a.indexOf(v) === i; });
  }

  var lastBlock = false;
  var lastCount = null;
  function isGame(it) { return it.properties && it.properties._addon === 'game'; }
  /* A game add-on needs a CONSOLE to attach to. This used to check for any
     non-game line, which meant a camera counted - so "camera + PS5 game"
     passed the guard and shipped a game with nothing to play it on.
     isConsole() below excludes cameras, so that case is now caught. */
  function gamesOnly(cart) { var items = cart.items || []; return items.length > 0 && items.some(isGame) && !items.some(isConsole); }

  /* ---- One console per order -------------------------------------------
     BookEasy stores rental DAYS as the line quantity, so a 4-day rental has
     quantity 4. Quantity therefore says nothing about how many consoles are
     in the cart - count distinct non-add-on LINES instead.
     Two lines of the same console on different dates still count as two.

     CAMERAS ARE EXEMPT. Their product_type is "Camera Rental" (consoles are
     "PS5 Rental" / "PS4 Rental"). Renting two cameras, or a camera alongside
     a console, stays allowed - this rule is about consoles only.
     Anything whose product_type we don't recognise is treated as a console,
     so a future console type is guarded by default rather than slipping
     through unchecked. */
  function isCamera(it) {
    return /camera/i.test((it.product_type || '') + ' ' + (it.product_title || ''));
  }
  function isConsole(it) { return !isGame(it) && !isCamera(it); }
  function consoleLines(cart) {
    return (cart.items || []).filter(isConsole);
  }
  function multiConsole(cart) { return consoleLines(cart).length > 1; }

  /* Highest-priority reason to block checkout, or null when the cart is fine. */
  function blockReason(cart) {
    if (multiConsole(cart)) return 'multi-console';
    if (gamesOnly(cart)) return 'games-only';
    return null;
  }

  var GSTORE = 'cpga_pending_games';
  function loadPending() { try { return JSON.parse(localStorage.getItem(GSTORE) || '[]'); } catch (e) { return []; } }
  function clearPending() { try { localStorage.removeItem(GSTORE); } catch (e) {} }
  function attachPending() {
    var pending = loadPending();
    if (!pending.length) return Promise.resolve();
    return getCart().then(function (cart) {
      var items = cart.items || [];
      if (!items.some(function (it) { return !isGame(it); })) return;
      var inCart = {}, gameCount = 0;
      items.forEach(function (it) { if (isGame(it)) { inCart[String(it.variant_id)] = 1; gameCount++; } });
      var room = Math.max(0, 3 - gameCount);
      var toAdd = pending.filter(function (v) { return !inCart[String(v)]; }).slice(0, room);
      if (!toAdd.length) { clearPending(); return; }
      var body = { items: toAdd.map(function (v) { return { id: Number(v), quantity: 1, properties: { _addon: 'game' } }; }) };
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) {
          if (!r.ok) throw new Error();
          clearPending();
          if (location.pathname.indexOf('/cart') === 0) { return refreshCartInPlace().then(function () { applyGuard(); }).catch(function () { location.reload(); }); }
        })
        .catch(function () {});
    });
  }
  function cartSectionId() {
    var f = document.querySelector('form[action^="/cart"]');
    var s = f && f.closest && f.closest('[id^="shopify-section-"]');
    return s ? s.id.replace(/^shopify-section-/, '') : null;
  }
  function refreshCartInPlace() {
    var id = cartSectionId(); if (!id) return Promise.reject();
    return fetch('/?section_id=' + encodeURIComponent(id)).then(function (r) { return r.text(); }).then(function (html) {
      var cur = document.getElementById('shopify-section-' + id);
      if (!cur || !html) throw new Error();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + id);
      cur.innerHTML = fresh ? fresh.innerHTML : html;
    });
  }

  function updateBadges(n) {
    document.querySelectorAll('.bigcounter').forEach(function (el) { if (el.children.length === 0) el.textContent = String(n); });
  }
  function drawerSectionId() {
    var d = document.querySelector('#ltn__utilize-cart-menu');
    var s = d && d.closest && d.closest('[id^="shopify-section-"]');
    return s ? s.id.replace(/^shopify-section-/, '') : null;
  }
  function refreshDrawer() {
    var id = drawerSectionId(); if (!id) return Promise.resolve();
    return fetch('/?section_id=' + encodeURIComponent(id)).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('#ltn__utilize-cart-menu');
      var cur = document.querySelector('#ltn__utilize-cart-menu');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  var PS5_COLLECTION = '/collections/play-station-5';

  /* applyGuard used to be able to run concurrently: the MutationObserver, the
     initial run() and the drawer refresh could each start their own getCart().
     Those promises resolve out of order, so a stale result could land on the
     DOM after a fresh one and silently un-block checkout. Everything is
     serialised now: one pass at a time, with at most one queued re-run. */
  var inFlight = false, queued = false;

  function applyOnce() {
    return getCart().then(function (cart) {
      var reason = blockReason(cart);
      var block = !!reason;
      lastBlock = block;
      window.__cpgaBundleHref = (reason === 'games-only') ? PS5_COLLECTION : null;
      checkoutEls().forEach(function (el) {
        if (block) { el.setAttribute('aria-disabled', 'true'); el.style.opacity = '0.45'; el.style.cursor = 'not-allowed'; el.setAttribute('data-cpga-blocked', '1'); }
        else if (el.getAttribute('data-cpga-blocked')) { el.removeAttribute('aria-disabled'); el.style.opacity = ''; el.style.cursor = ''; el.removeAttribute('data-cpga-blocked'); }
      });
      setNote(reason);
      updateBadges(cart.item_count);
      var changed = (lastCount !== null && cart.item_count !== lastCount);
      lastCount = cart.item_count;
      if (changed) { return refreshDrawer(); }
    });
  }

  function applyGuard() {
    if (inFlight) { queued = true; return Promise.resolve(lastBlock); }
    inFlight = true;
    return applyOnce().catch(function () {}).then(function () {
      inFlight = false;
      if (queued) { queued = false; return applyGuard(); }
      return lastBlock;
    });
  }

  function noteAnchor() {
    var target = checkoutEls().filter(function (el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0; })[0] || checkoutEls()[0];
    if (!target || !target.parentNode) return null;
    var row = target.parentElement;
    try {
      var d = getComputedStyle(row).display;
      if ((d === 'flex' || d === 'inline-flex') && row.children.length > 1 && row.parentNode) { return { parent: row.parentNode, before: row }; }
    } catch (e) {}
    return { parent: target.parentNode, before: target };
  }

  /* reason: 'multi-console' | 'games-only' | null */
  function setNote(reason) {
    var show = !!reason;
    var n = document.getElementById('cpga-guard-note');
    if (!n && show) {
      n = document.createElement('div');
      n.id = 'cpga-guard-note';
      n.style.cssText = 'display:block;width:100%;box-sizing:border-box;margin:12px 0;padding:12px 14px;border:1px solid #f0c000;background:#fff8e1;border-radius:10px;font-size:14px;line-height:1.45;color:#5c4400;';
    }
    if (n && show) {
      if (reason === 'multi-console') {
        n.innerHTML = 'You can rent <strong>one console per order</strong>. Remove one from your cart to continue.';
      } else {
        var href = window.__cpgaBundleHref || '/collections/play-station-5';
        n.innerHTML = 'A game cannot be rented on its own. Add a PS5 rental to continue - <a href="' + href + '" style="color:#7b5cff;font-weight:600;text-decoration:underline;">choose a PS5</a>.';
      }
      var a = noteAnchor();
      if (a && (n.parentNode !== a.parent || n.nextSibling !== a.before)) { a.parent.insertBefore(n, a.before); }
    }
    if (n) n.style.display = show ? 'block' : 'none';
  }

  function isCheckoutTarget(el) {
    if (!el || !el.matches) return false;
    if (el.matches('[data-cpga-blocked], button[name=checkout], a[href*="/checkout"], .cart__checkout, .shopify-payment-button__button')) return true;
    var t = (el.textContent || '').trim().toLowerCase();
    return t === 'checkout' || t === 'proceed to checkout' || t === 'check out';
  }
  function stopIt(e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); }
  function showNote() { applyGuard(); var n = document.getElementById('cpga-guard-note'); if (n) n.scrollIntoView({ behavior: 'smooth', block: 'center' }); }

  var bypass = false;
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('a,button');
    if (!el || !isCheckoutTarget(el)) return;
    if (bypass) return;
    stopIt(e);
    var proceed = function () {
      bypass = true;
      if (el.tagName === 'A') { window.location.href = el.getAttribute('href') || '/checkout'; }
      else { el.click(); }
      setTimeout(function () { bypass = false; }, 0);
    };
    getCart().then(function (cart) { if (blockReason(cart)) { showNote(); } else { proceed(); } }).catch(function () { if (lastBlock) { showNote(); } else { proceed(); } });
  }, true);

  function run() { attachPending().then(clampAddons).then(applyGuard).catch(applyGuard); }
  var t; function debounced() { clearTimeout(t); t = setTimeout(applyGuard, 300); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('cart:refresh', run);
  try { new MutationObserver(debounced).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
})();
